// extracted by mini-css-extract-plugin
export default {"submitButton":"_3e2fktxDnAJuxSfNUp3SgA success expand large","heading":"_5xHFYS2nwrm6ybnVAEB4VC","subHeading":"_4XCg90A00x6h90tqfIeNhT","form":"XgjimJu8Enpl3HZOAjCDD"};